import { useEffect, useState } from "react";
import { TextField } from "@mui/material";

export default function TrackingNumberField({ trackingNumber, disabled, onSave }: {
  trackingNumber: string | null;
  disabled: boolean;
  onSave: (value: string | null) => Promise<boolean>;
}) {
  const [value, setValue] = useState(trackingNumber ?? "");
  useEffect(() => { setValue(trackingNumber ?? ""); }, [trackingNumber]);

  const save = async () => {
    const next = value.replace(/[\s-]+/g, "");
    setValue(next);
    if (next === (trackingNumber ?? "")) return;
    if (!await onSave(next || null)) setValue(trackingNumber ?? "");
  };

  return (
    <TextField
      placeholder="Tracking number"
      size="small"
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onBlur={save}
      disabled={disabled}
      sx={{ mt: 1, width: 320, maxWidth: "100%" }}
    />
  );
}
